import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["alt", "name"]
const _hoisted_2 = {
  key: 0,
  class: "d-md-block",
  alt: "Bandiera Italiana"
}
const _hoisted_3 = {
  key: 1,
  class: "d-md-block",
  alt: "English Flag"
}
const _hoisted_4 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded fw-bold fs-7 w-200px py-4",
  "data-kt-menu": "true"
}
const _hoisted_5 = { class: "menu-item px-3" }
const _hoisted_6 = { class: "menu-item px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn-language-switcher btn btn-flex flex-center h-40px px-6 px-md-6",
      alt: _ctx.translate('LANGUAGE_SELECTED'),
      role: "button",
      "data-kt-menu-trigger": "hover",
      "data-kt-menu-placement": "bottom-end",
      id: "language-button",
      "aria-expanded": "false",
      "aria-controls": "language-button",
      "aria-haspopup": "listbox",
      name: _ctx.translate('languages')
    }, [
      _createVNode(_component_inline_svg, {
        src: "/media/vectorial/globe.svg",
        style: {"margin-right":"5px","margin-bottom":"1px"},
        "aria-hidden": "true"
      }),
      (_ctx.currentLanguage('it'))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ITA "))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " ENG ")),
      _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "fas fa-chevron-down h-2px",
        style: {"margin-left":"5px","color":"#050505"}
      }, null, -1))
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'))),
          href: "javascript:void(0)",
          class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }]),
          alt: "Select English Language"
        }, " English ", 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('it'))),
          href: "javascript:void(0)",
          class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('it') }]),
          alt: "Seleziona Lingua Italiana"
        }, " Italiano ", 2)
      ])
    ])
  ], 64))
}